import useLocale from '@/i18n/useLocale'
import { useTranslations } from 'next-intl'

const UNITS_IN_MILLISECS = {
  year: 31536000000,
  month: 2628000000,
  day: 86400000,
  hour: 3600000,
  minute: 60000,
  second: 1000,
}

function useRelativeTimeFromTimestamp(timestamp: Date) {
  const locale = useLocale()
  const t = useTranslations('nextjs.core')
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  const elapsedTime = new Date().getTime() - new Date(timestamp).getTime()

  if (elapsedTime < UNITS_IN_MILLISECS.minute) {
    return t('just_now')
  }

  const unit = Object.keys(UNITS_IN_MILLISECS).find(
    (key) => elapsedTime >= UNITS_IN_MILLISECS[key as keyof typeof UNITS_IN_MILLISECS]
  ) as keyof typeof UNITS_IN_MILLISECS

  return rtf.format(-Math.round(elapsedTime / UNITS_IN_MILLISECS[unit]), unit)
}

export default useRelativeTimeFromTimestamp
